export enum Loading {
  NotLoaded = 0,
  Loading = 1,
  Success = 2,
  Failure = 3,
}
